import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchEnvLogDetail, fetchEnvLogList } from '@/domains/log/apis/env-log';
import type {
  LogEnvDetailResponse,
  LogEnvListResponse,
  UseEnvLogProps,
} from '@/domains/log/types/env-log.types';

const useEnvLog = ({ queryParams = '', request_id = '' }: UseEnvLogProps) => {
  const {
    data: logEnvListData,
    isLoading: isListLoading,
    isFetching: isListFetching,
  } = useQuery<LogEnvListResponse>({
    queryKey: ['logEnvListData', queryParams],
    queryFn: () => fetchEnvLogList(queryParams),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 1,
  });

  const { data: logEnvDetailData, refetch: refetchLogEnvDetail } = useQuery<LogEnvDetailResponse>({
    queryKey: ['logEnvDetailData', request_id],
    queryFn: () => fetchEnvLogDetail(request_id as string),
    retry: false,
    enabled: !!request_id,
  });

  return {
    logEnvListData,
    logEnvDetailData,
    refetchLogEnvDetail,
    isListLoading,
    isListFetching,
  };
};

export default useEnvLog;
